import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import { Flex, Badge, Tooltip, IconButton, Box } from 'pcln-design-system';
import RealtimeHeaderIcon from '../../../svgs/RealtimeHeaderIcon';
import RealtimeWaveIcon from '../../../svgs/RealtimeWaveIcon';
import { InformationOutline } from 'pcln-icons';
import { ChatbotDataContext } from '../../../context/ChatbotDataContext';
const StyledTooltip = /*#__PURE__*/styled(Tooltip).withConfig({
  displayName: "RealTimeHeader__StyledTooltip",
  componentId: "sc-17p9ngw-0"
})(["left:", ";width:", ";text-align:left;"], ({
  isMobile
}) => isMobile ? '16px' : '-8px', (isMobile, isStandalone) => isStandalone && isMobile ? '145px' : '300px');
const RealTimeHeader = ({
  isStandalone
}) => {
  const [isDisplayed, setTooltipDisplayState] = useState(false);
  const {
    isMobile
  } = useContext(ChatbotDataContext);
  const IconButtonProps = {
    ml: 2,
    id: 'openTooltipButton',
    'data-testid': 'openTooltipButton',
    title: 'open tooltip',
    onClick: e => {
      e.preventDefault();
      setTooltipDisplayState(!isDisplayed);
    },
    icon: React.createElement(InformationOutline, {
      size: 16
    })
  };
  return React.createElement(Flex, {
    alignItems: 'center',
    justifyContent: 'center'
  }, React.createElement(RealtimeHeaderIcon, null), React.createElement(Badge, {
    color: 'primary',
    bg: 'background.light',
    ml: 1
  }, "BETA"), React.createElement(Box, {
    mr: '0',
    color: 'white'
  }, React.createElement(IconButton, Object.assign({}, IconButtonProps, {
    onClick: function () {
      setTooltipDisplayState(!isDisplayed);
    }
  })), isDisplayed && React.createElement(StyledTooltip, {
    isStandalone: isStandalone,
    bg: 'background.darkest',
    color: 'background.lightest',
    center: isMobile,
    left: !isMobile,
    isMobile: isMobile
  }, "Powered by OpenAI. Chat transcripts are recorded for quality review purposes. Penny can make mistakes. Please do not share any personal information in the chat.", React.createElement("br", null), React.createElement("br", null), "\u00A9 ", new Date().getFullYear(), " Priceline - Patent Pending")), React.createElement(RealtimeWaveIcon, null));
};
export default RealTimeHeader;